var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.data.nodes),function(field,index){return _c('div',{key:index,staticClass:"gl-inline-block gl-pr-2"},[_c(_vm.presenter.forField(field),{tag:"component"})],1)}),_vm._v(" "),(!_vm.data.nodes.length)?_c('null-presenter'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }